import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const rovoVideoModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(async () =>
		import(/* webpackChunkName: "async-rovo-video-modal-feature" */ './src/index').then(
			({ RovoVideoModal }) => RovoVideoModal,
		),
	),
	getPreloadProps: () => ({}),
});
